import { IConfig } from "../types/IConfig"

export const normalizePosition = (config: IConfig) => {
  const position = config.position || config.type;

  if (position?.startsWith('reward')) return 'reward';
  if (position?.startsWith('intersti')) return 'interstitial';

  return 'pre-roll';
}
